import React, {useState} from "react"

import RightWorkBtn from "./RightWorkBtn"

import "./rightworkarea.scss"
/**
 * The button inside which buttons with functions for active objects are hidden
 * @component
 * @param  {object} props
 * @param  {string} props.icon - icon url for button icon
 * @param  {string} props.label - text inside button
 * @param  {Array} props.btns - buttons array
 * @param  {Array} props.activeObjs - array of selectted object
 * @param  {object} props.activeObj - selected object
 * @param  {function} props.actionHandler - handler button onclick function
 * @param  {string} props.value - value button onclick value
 *
 * @example
 * const icon = "",
 * const label = "",
 * const btns = [],
 * const activeObjs = [],
 * const activeObj = {},
 * const actionHandler = () => {},
 *
 * return (
 *  <LeftPanelBtn
 *   icon={icon}
 *   label={label}
 *   btns={btns}
 *   activeObjs={activeObjs}
 *   activeObj={activeObj}
 *   actionHandler={actionHandler}
 *  />
 * )
 */

const HoveredBtn = props => {
  const {
    icon = "",
    label = "",
    btns = [],
    activeObjs = [],
    activeObj = {},
    actionHandler = () => {},
  } = props

  const [active, setActive] = useState(false)

  const handleOpen = () => setActive(true)
  const handleClose = () => setActive(false)

  return (
    <div
      className="rightWorkAreaHovered"
      onMouseEnter={handleOpen}
      onMouseLeave={handleClose}
    >
      <div className="rightWorkAreaBtn">
        <img src={icon} alt={label} />
        <span>{label}</span>
      </div>
      {active ? (
        <div
          className="rightWorkAreaBtns_cont"
          style={{width: `calc(100% * ${btns.length})`}}
        >
          {btns.map(item => (
            <RightWorkBtn
              key={`_key${item.label}$`}
              label={item.label}
              name={item.name}
              icon={item.icon}
              handler={actionHandler}
              disabled={
                (item.forOne && activeObjs.length > 1) ||
                (item.forOne && activeObj && activeObj.type === "rect")
              }
            />
          ))}
        </div>
      ) : null}
    </div>
  )
}

export default HoveredBtn
